


















































import MobileMenu from '@/components/general/mobileMenu/MobileMenu.vue';
import MobileMenuEntry from '@/components/general/mobileMenu/MobileMenuEntry.vue';
import { ICategory, IRootCategory } from '@/contract/category.contract';
import { INamedGroup } from '@/contract/named-group.contract';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    MobileMenu,
    MobileMenuEntry,
  },
})
export default class SearchCategoriesMobile extends Vue {
  @Prop()
  public rootCategories!: IRootCategory[];

  public activeRoot: IRootCategory | null = null;

  public activeSubCategory: INamedGroup<ICategory> | null = null;

  public isOverlayOpen = false;

  @Watch('activeRoot')
  public onactiveRootChanged() {
    if (this.activeRoot) {
      this.isOverlayOpen = true;
    }
  }

  public handleOverlayVisibleChanged(): void {
    if (!this.isOverlayOpen) {
      this.handleRootCategorySelected(null);
    }
  }

  public handleRootCategorySelected(category: IRootCategory | null) {
    this.activeSubCategory = null;
    this.activeRoot = category;
  }

  public handleCategorySelected(category: ICategory) {
    this.isOverlayOpen = false;
    this.$emit('category-selected', this.activeRoot, category);
    this.activeRoot = null;
    this.activeSubCategory = null;
  }

  public handleToOverviewClicked() {
    this.isOverlayOpen = false;
    this.handleRootCategorySelected(null);
  }
}
